import PhoneInput from "react-phone-input-2";
import { useInputPhone } from "./input-phone.hook";
import { InputPhoneProps } from "src/types";
import { formatLabelWithCondition } from "src/utils";

export const InputPhone = (props: InputPhoneProps) => {
  const { touched, error, value, name, placeholder, label, requiredCondition } =
    props;
  const { country, onChangePhone, onBlurPhone } = useInputPhone(props);

  const id = `input-${name}.formattedPhone`;

  return (
    <div
      className={
        !touched?.formattedPhone || !error?.formattedPhone ? "mb-4" : "mb-3"
      }
    >
      <label htmlFor={id} className="input-text--label d-block mb-md-2 mb-1">
        {formatLabelWithCondition(label, requiredCondition)}
      </label>
      <div
        className={
          touched?.formattedPhone && error?.formattedPhone
            ? "phone-style-error"
            : "phone-style"
        }
      >
        <PhoneInput
          country={country}
          placeholder={placeholder}
          value={value?.formattedPhone}
          onChange={onChangePhone}
          onBlur={onBlurPhone}
          specialLabel={""}
          inputProps={{
            id: id,
            name: name,
            autoComplete: "tel",
            inputMode: "tel",
          }}
        />
      </div>
      {touched?.formattedPhone && error?.formattedPhone && (
        <div className="font-14 c-error">{error?.formattedPhone}</div>
      )}
    </div>
  );
};
